import { styled } from '@linaria/react';
import { colors, fonts, layout, semantic } from '../../theme/tokens';

export { Badge, IconWrapper } from '../../styles/nav.styles';

export const Rail = styled.nav`
  display: none;

  @media (min-width: ${layout.desktopBreakpoint}) {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-shrink: 0;
    width: ${layout.sideNavWidth};
    height: var(--layout-viewport-height, 100vh);
    padding-top: 20px;
    gap: 4px;
    border-right: 1px solid ${semantic.border.default};
    background: ${colors.white};
    position: sticky;
    top: var(--announcement-banner-height, 0px);
    align-self: flex-start;
    z-index: 102;
  }
`;

export const TopItems = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
`;

export const BottomItems = styled.div`
  margin-top: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding-bottom: 20px;
`;

export const NavItem = styled.button<{ $active?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 10px 4px;
  width: 64px;
  background: none;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  color: ${({ $active }) => ($active ? semantic.text.primary : colors.sectionTitle)};
  transition: color 0.15s ease, background 0.15s ease;

  &:hover {
    color: ${semantic.text.primary};
    background: ${semantic.bg.surfaceSubtle};
  }
`;

export const NavLabel = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  font-weight: ${fonts.weight.medium};
  letter-spacing: 0.2px;
`;
